var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('b-container',[_c('b-row',{staticClass:"py-2 py-md-2",staticStyle:{"padding":"0px !important"}},[_c('b-col',{staticClass:"text-left",attrs:{"cols":"12","md":"12"}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }